"use strict";

!(function (t, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
    ? define(e)
    : ((t = "undefined" != typeof globalThis ? globalThis : t || self).dayjs =
        e());
})(this, function () {
  "use strict";
  var t = 1e3,
    e = 6e4,
    n = 36e5,
    r = "millisecond",
    i = "second",
    s = "minute",
    u = "hour",
    a = "day",
    o = "week",
    f = "month",
    h = "quarter",
    c = "year",
    d = "date",
    $ = "Invalid Date",
    l =
      /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
    y =
      /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
    M = {
      name: "en",
      weekdays:
        "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months:
        "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ),
    },
    m = function (t, e, n) {
      var r = String(t);
      return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    },
    g = {
      s: m,
      z: function (t) {
        var e = -t.utcOffset(),
          n = Math.abs(e),
          r = Math.floor(n / 60),
          i = n % 60;
        return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
      },
      m: function t(e, n) {
        if (e.date() < n.date()) return -t(n, e);
        var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
          i = e.clone().add(r, f),
          s = n - i < 0,
          u = e.clone().add(r + (s ? -1 : 1), f);
        return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
      },
      a: function (t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      },
      p: function (t) {
        return (
          { M: f, y: c, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: h }[t] ||
          String(t || "")
            .toLowerCase()
            .replace(/s$/, "")
        );
      },
      u: function (t) {
        return void 0 === t;
      },
    },
    D = "en",
    v = {};
  v[D] = M;
  var p = function (t) {
      return t instanceof _;
    },
    S = function (t, e, n) {
      var r;
      if (!t) return D;
      if ("string" == typeof t) v[t] && (r = t), e && ((v[t] = e), (r = t));
      else {
        var i = t.name;
        (v[i] = t), (r = i);
      }
      return !n && r && (D = r), r || (!n && D);
    },
    w = function (t, e) {
      if (p(t)) return t.clone();
      var n = "object" == typeof e ? e : {};
      return (n.date = t), (n.args = arguments), new _(n);
    },
    O = g;
  (O.l = S),
    (O.i = p),
    (O.w = function (t, e) {
      return w(t, { locale: e.$L, utc: e.$u, x: e.$x, $offset: e.$offset });
    });
  var _ = (function () {
      function M(t) {
        (this.$L = S(t.locale, null, !0)), this.parse(t);
      }
      var m = M.prototype;
      return (
        (m.parse = function (t) {
          (this.$d = (function (t) {
            var e = t.date,
              n = t.utc;
            if (null === e) return new Date(NaN);
            if (O.u(e)) return new Date();
            if (e instanceof Date) return new Date(e);
            if ("string" == typeof e && !/Z$/i.test(e)) {
              var r = e.match(l);
              if (r) {
                var i = r[2] - 1 || 0,
                  s = (r[7] || "0").substring(0, 3);
                return n
                  ? new Date(
                      Date.UTC(
                        r[1],
                        i,
                        r[3] || 1,
                        r[4] || 0,
                        r[5] || 0,
                        r[6] || 0,
                        s
                      )
                    )
                  : new Date(
                      r[1],
                      i,
                      r[3] || 1,
                      r[4] || 0,
                      r[5] || 0,
                      r[6] || 0,
                      s
                    );
              }
            }
            return new Date(e);
          })(t)),
            (this.$x = t.x || {}),
            this.init();
        }),
        (m.init = function () {
          var t = this.$d;
          (this.$y = t.getFullYear()),
            (this.$M = t.getMonth()),
            (this.$D = t.getDate()),
            (this.$W = t.getDay()),
            (this.$H = t.getHours()),
            (this.$m = t.getMinutes()),
            (this.$s = t.getSeconds()),
            (this.$ms = t.getMilliseconds());
        }),
        (m.$utils = function () {
          return O;
        }),
        (m.isValid = function () {
          return !(this.$d.toString() === $);
        }),
        (m.isSame = function (t, e) {
          var n = w(t);
          return this.startOf(e) <= n && n <= this.endOf(e);
        }),
        (m.isAfter = function (t, e) {
          return w(t) < this.startOf(e);
        }),
        (m.isBefore = function (t, e) {
          return this.endOf(e) < w(t);
        }),
        (m.$g = function (t, e, n) {
          return O.u(t) ? this[e] : this.set(n, t);
        }),
        (m.unix = function () {
          return Math.floor(this.valueOf() / 1e3);
        }),
        (m.valueOf = function () {
          return this.$d.getTime();
        }),
        (m.startOf = function (t, e) {
          var n = this,
            r = !!O.u(e) || e,
            h = O.p(t),
            $ = function (t, e) {
              var i = O.w(
                n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t),
                n
              );
              return r ? i : i.endOf(a);
            },
            l = function (t, e) {
              return O.w(
                n
                  .toDate()
                  [t].apply(
                    n.toDate("s"),
                    (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)
                  ),
                n
              );
            },
            y = this.$W,
            M = this.$M,
            m = this.$D,
            g = "set" + (this.$u ? "UTC" : "");
          switch (h) {
            case c:
              return r ? $(1, 0) : $(31, 11);
            case f:
              return r ? $(1, M) : $(0, M + 1);
            case o:
              var D = this.$locale().weekStart || 0,
                v = (y < D ? y + 7 : y) - D;
              return $(r ? m - v : m + (6 - v), M);
            case a:
            case d:
              return l(g + "Hours", 0);
            case u:
              return l(g + "Minutes", 1);
            case s:
              return l(g + "Seconds", 2);
            case i:
              return l(g + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }),
        (m.endOf = function (t) {
          return this.startOf(t, !1);
        }),
        (m.$set = function (t, e) {
          var n,
            o = O.p(t),
            h = "set" + (this.$u ? "UTC" : ""),
            $ = ((n = {}),
            (n[a] = h + "Date"),
            (n[d] = h + "Date"),
            (n[f] = h + "Month"),
            (n[c] = h + "FullYear"),
            (n[u] = h + "Hours"),
            (n[s] = h + "Minutes"),
            (n[i] = h + "Seconds"),
            (n[r] = h + "Milliseconds"),
            n)[o],
            l = o === a ? this.$D + (e - this.$W) : e;
          if (o === f || o === c) {
            var y = this.clone().set(d, 1);
            y.$d[$](l),
              y.init(),
              (this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d);
          } else $ && this.$d[$](l);
          return this.init(), this;
        }),
        (m.set = function (t, e) {
          return this.clone().$set(t, e);
        }),
        (m.get = function (t) {
          return this[O.p(t)]();
        }),
        (m.add = function (r, h) {
          var d,
            $ = this;
          r = Number(r);
          var l = O.p(h),
            y = function (t) {
              var e = w($);
              return O.w(e.date(e.date() + Math.round(t * r)), $);
            };
          if (l === f) return this.set(f, this.$M + r);
          if (l === c) return this.set(c, this.$y + r);
          if (l === a) return y(1);
          if (l === o) return y(7);
          var M = ((d = {}), (d[s] = e), (d[u] = t), d)[l] || 1,
            m = this.$d.getTime() + r * M;
          return O.w(m, this);
        }),
        (m.subtract = function (t, e) {
          return this.add(-1 * t, e);
        }),
        (m.format = function (t) {
          var e = this,
            n = this.$locale();
          if (!this.isValid()) return n.invalidDate || $;
          var r = t || "YYYY-MM-DDTHH:mm:ssZ",
            i = O.z(this),
            s = this.$H,
            u = this.$m,
            a = this.$M,
            o = n.weekdays,
            f = n.months,
            h = function (t, n, i, s) {
              return (t && (t[n] || t(e, r))) || i[n].substr(0, s);
            },
            c = function (t) {
              return O.s(s % 12 || 12, t, "0");
            },
            d =
              n.meridiem ||
              function (t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
              },
            l = {
              YY: String(this.$y).slice(-2),
              YYYY: this.$y,
              M: a + 1,
              MM: O.s(a + 1, 2, "0"),
              MMM: h(n.monthsShort, a, f, 3),
              MMMM: h(f, a),
              D: this.$D,
              DD: O.s(this.$D, 2, "0"),
              d: String(this.$W),
              dd: h(n.weekdaysMin, this.$W, o, 2),
              ddd: h(n.weekdaysShort, this.$W, o, 3),
              dddd: o[this.$W],
              H: String(s),
              HH: O.s(s, 2, "0"),
              h: c(1),
              hh: c(2),
              a: d(s, u, !0),
              A: d(s, u, !1),
              m: String(u),
              mm: O.s(u, 2, "0"),
              s: String(this.$s),
              ss: O.s(this.$s, 2, "0"),
              SSS: O.s(this.$ms, 3, "0"),
              Z: i,
            };
          return r.replace(y, function (t, e) {
            return e || l[t] || i.replace(":", "");
          });
        }),
        (m.utcOffset = function () {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }),
        (m.diff = function (r, d, $) {
          var l,
            y = O.p(d),
            M = w(r),
            m = (M.utcOffset() - this.utcOffset()) * e,
            g = this - M,
            D = O.m(this, M);
          return (
            (D =
              ((l = {}),
              (l[c] = D / 12),
              (l[f] = D),
              (l[h] = D / 3),
              (l[o] = (g - m) / 6048e5),
              (l[a] = (g - m) / 864e5),
              (l[u] = g / n),
              (l[s] = g / e),
              (l[i] = g / t),
              l)[y] || g),
            $ ? D : O.a(D)
          );
        }),
        (m.daysInMonth = function () {
          return this.endOf(f).$D;
        }),
        (m.$locale = function () {
          return v[this.$L];
        }),
        (m.locale = function (t, e) {
          if (!t) return this.$L;
          var n = this.clone(),
            r = S(t, e, !0);
          return r && (n.$L = r), n;
        }),
        (m.clone = function () {
          return O.w(this.$d, this);
        }),
        (m.toDate = function () {
          return new Date(this.valueOf());
        }),
        (m.toJSON = function () {
          return this.isValid() ? this.toISOString() : null;
        }),
        (m.toISOString = function () {
          return this.$d.toISOString();
        }),
        (m.toString = function () {
          return this.$d.toUTCString();
        }),
        M
      );
    })(),
    b = _.prototype;
  return (
    (w.prototype = b),
    [
      ["$ms", r],
      ["$s", i],
      ["$m", s],
      ["$H", u],
      ["$W", a],
      ["$M", f],
      ["$y", c],
      ["$D", d],
    ].forEach(function (t) {
      b[t[1]] = function (e) {
        return this.$g(e, t[0], t[1]);
      };
    }),
    (w.extend = function (t, e) {
      return t.$i || (t(e, _, w), (t.$i = !0)), w;
    }),
    (w.locale = S),
    (w.isDayjs = p),
    (w.unix = function (t) {
      return w(1e3 * t);
    }),
    (w.en = v[D]),
    (w.Ls = v),
    (w.p = {}),
    w
  );
});
(function ($, dayjs) {
  "use strict";

  function mainSlider() {
    var $slideshow = $(".home-slider");
    $slideshow.owlCarousel({
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      mouseDrag: false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed: 450,
      nav: false,
      loop: true,
      lazyContent: true,
      autoplay: true,
      autoplayTimeout: 5000,
    });
  }

  function owlSlider() {
    $(".related-products-items.owl-carousel").owlCarousel({
      loop: true,
      margin: 15,
      stagePadding: 50,
      center: true,
      nav: true,
      dots: false,
      lazyLoad: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          margin: 5,
          nav: true,
        },
        600: {
          items: 2,
          margin: 10,
          nav: true,
        },
        1000: {
          items: 3,
          nav: true,
        },
      },
    }); //Home Product Slider

    $(".home-products__slider").owlCarousel({
      loop: false,
      margin: 0,
      nav: true,
      dots: true,
      lazyLoad: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          margin: 0,
          nav: true,
          dots: true,
        },
        600: {
          items: 2,
          margin: 0,
          nav: true,
          dots: true,
        },
        1000: {
          items: 3,
          nav: true,
          dots: true,
        },
      },
    }); //Charity Card Page

    $(".page-charity-card-slideshow").owlCarousel({
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      mouseDrag: false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed: 450,
      nav: true,
      loop: true,
      lazyContent: true,
      autoplay: true,
      autoplayTimeout: 5000,
    });
  }

  function scrollHash() {
    $("a.scroll-hash").on("click", function (event) {
      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault(); // Store hash

        var hash = this.hash; // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area

        $("html, body").animate(
          {
            scrollTop: $(hash).offset().top - 76,
          },
          1000,
          function () {
            // Add hash (#) to URL when done scrolling (default click behavior)
            //window.location.hash = hash;
          }
        );
      } // End if
    });
  }

  function fullPageNav() {
    $("#ProductNavThumbs").fullPageNav();
  }

  function accordionTabs() {
    $(".accordion").accordion({
      transitionSpeed: 100,
    });
  } //Sticky Header

  var stickyNav = function stickyNav() {
    var stickyElement = $(".site-header"),
      stickyClass = "isStuck",
      stickyPos = stickyElement.offset().top,
      //Distance from the top of the window.
      stickyHeight; //Create a negative margin to prevent content 'jumps':

    stickyElement.after('<div class="jumps-prevent"></div>');

    function jumpsPrevent() {
      stickyHeight = stickyElement.innerHeight();
      stickyElement.css({
        "margin-bottom": "-" + stickyHeight + "px",
      });
      stickyElement.next().css({
        "padding-top": +stickyHeight + "px",
      });
    }

    jumpsPrevent(); //Run.
    //Function trigger:

    $(window).resize(function () {
      jumpsPrevent();
    }); //Sticker function:

    function stickerFn() {
      var winTop = $(window).scrollTop(); //Check element position:

      if (stickyPos < 0 && winTop == 0) {
        stickyElement.removeClass(stickyClass);
      } else if (winTop >= stickyPos && winTop != 0) {
        stickyElement.addClass(stickyClass);
      } else if (winTop == 0 && stickyPos == 0) {
        stickyElement.removeClass(stickyClass);
      } else {
        stickyElement.removeClass(stickyClass);
      }
    }

    stickerFn(); //Run.
    //Function trigger:

    $(window).scroll(function () {
      stickerFn();
    });
  }; // End Sticky Header

  function testimonial() {
    $(".testimonial-slider").owlCarousel({
      animateOut: "fadeOut",
      animateIn: "fadeIn",
      mouseDrag: true,
      items: 3,
      margin: 55,
      stagePadding: 0,
      smartSpeed: 450,
      nav: false,
      loop: true,
      lazyContent: true,
      autoplay: false,
      autoplayTimeout: 7000,
      autoHeight: true,
      responsive: {
        // 0: {
        //   nav: true,
        //   dots: true
        // },
        // 600: {
        //   nav: true,
        //   dots: true
        // },
        0: {
          nav: true,
          dots: true,
          items: 1,
        },
        768: {
          nav: true,
          dots: true,
          items: 2,
        },
        1220: {
          items: 3,
          nav: false,
          dots: false,
        },
      },
    });
  }

  function ctaPopup() {
    $(".cta__btn").magnificPopup({
      type: "inline",
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "cta-popup__container my-mfp-slide-bottom",
    });
    $(".btn-popup").magnificPopup({
      type: "inline",
      fixedContentPos: true,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: true,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: "delivery-popup__container my-mfp-slide-bottom",
    });
  }

  function videoPopup() {
    $(".video--popup").magnificPopup({
      disableOn: false,
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
    });
  }

  function searchToggle() {
    var searchContainer = $("#header-search-bar"),
      searchOpen = $(".site-header__search-trigger"),
      searchClose = searchContainer.find(".site-header__search-close");
    searchOpen.click(function (evt) {
      evt.preventDefault();

      if (searchContainer.hasClass("active")) {
        searchContainer.removeClass("active");
      } else {
        searchContainer.addClass("active");
        setTimeout(function () {
          searchContainer.find("input#search-bar__input").focus();
        }, 500);
      }
    });
    searchClose.click(function () {
      searchContainer.removeClass("active");
    });
  }
  /* Sale bar */

  function hideSaleBar() {
    $("html").removeClass("sale-banner-enabled");
  }

  function showSaleBar() {
    $("html").addClass("sale-banner-enabled");
  }

  if (sessionStorage.getItem("pvSalePopup") != "hidden") {
    showSaleBar();
  }

  window.onload = function (e) {
    var clockDate = $(".sale-bar__timer").data("date"),
      clockTime = $(".sale-bar__timer").data("time"),
      eventTime = moment(
        clockDate + " " + clockTime,
        "MM-DD-YYYY HH:mm:ss U"
      ).unix(),
      currentTime = moment().unix(),
      diffTime = eventTime - currentTime,
      duration = moment.duration(diffTime * 1000, "milliseconds"),
      interval = 1000;
    var $d = $("[data-timer-days]"),
      $h = $("[data-timer-hours]"),
      $m = $("[data-timer-minutes]"),
      $s = $("[data-timer-seconds]");
    setInterval(function () {
      duration = moment.duration(
        duration.asMilliseconds() - interval,
        "milliseconds"
      );
      var d = moment.duration(duration).days(),
        h = moment.duration(duration).hours(),
        m = moment.duration(duration).minutes(),
        s = moment.duration(duration).seconds();
      d = $.trim(d).length === 1 ? "0" + d : d;
      h = $.trim(h).length === 1 ? "0" + h : h;
      m = $.trim(m).length === 1 ? "0" + m : m;
      s = $.trim(s).length === 1 ? "0" + s : s;
      $d.text(d);
      $h.text(h);
      $m.text(m);
      $s.text(s);
    }, interval);
    $("[data-promo-timer-close]").on("click", function () {
      hideSaleBar();
      sessionStorage.setItem("pvSalePopup", "hidden");
    });
  };
  /* End sale bar */

  function mobileFooter() {
    $(".site-footer__column > h3 > .mobile-clicker").click(function () {
      var $this = $(this).parents(".site-footer__column");
      $this.siblings().removeClass("open");

      if ($this.hasClass("open")) {
        $this.removeClass("open");
      } else {
        $this.addClass("open");
      }
    });
  }

  $(document).ready(function () {
    searchToggle();
    scrollHash();
    ctaPopup();
    new WOW().init();
    testimonial();
    owlSlider();
    mainSlider();
    fullPageNav();
    videoPopup();
    accordionTabs();
    stickyNav();
    mobileFooter(); // crosellSlider();

    $(".tooltip").tooltipster({
      animation: "fade",
      delay: 100,
      contentCloning: true,
      theme: "tooltipster-shadow",
    });
    lazySizes.init();
    $(window).load(function () {
      $(".preloader").addClass("none");
    });
    $(".site-nav--has-dropdown > a").click(function (e) {
      e.preventDefault();
      var $this = $(this).parent(),
        $navOverlay = $("#NavOverlay");
      $this.siblings().removeClass("dropdown--active");
      $navOverlay.removeClass("nav-overlay--active");

      if ($this.hasClass("dropdown--active")) {
        $navOverlay.removeClass("nav-overlay--active");
        $this
          .removeClass("dropdown--active")
          .parents(".site-header")
          .removeClass("header--active");
      } else {
        $navOverlay.addClass("nav-overlay--active");
        $this
          .addClass("dropdown--active")
          .parents(".site-header")
          .addClass("header--active");
      }
    });
    $("#NavOverlay").click(function () {
      var $this = $(this);
      $this.removeClass("nav-overlay--active");
      $(".site-nav--has-dropdown")
        .removeClass("dropdown--active")
        .parents(".site-header")
        .removeClass("header--active");
    });
  });
  $(window).load(function () {
    //$('body').css('opacity', '1');
    $(".cart-item__qty .js-qty__adjust").click(function () {
      $(".update-cart").trigger("click");
      console.log("clicked update");
    });
  }); // Delivery Date Picker

  var init_date_picker = function init_date_picker(configs, $) {
    var target = document.querySelector("input#day_delivery");
    var weekday = document.querySelector("input#weekday_delivery");
    var postcodeEL = document.querySelector("input#postcode_delivery");
    if (!target || !configs) return;

    function getToday(cutOffTime = "12:00") {
      let date = dayjs();
      // Parse cut-off time into hours and minutes
      const [hours, minutes] = cutOffTime.split(":").map(Number);

      // Check if current time is past cut-off
      if (
        date.hour() > hours ||
        (date.hour() === hours && date.minute() >= minutes)
      ) {
        date = date.add(1, "day");
        date = date.set("hour", 2).set("minute", 0).set("second", 0);
      }
      return date;
    }

    function convertToDayjs(date) {
      if (typeof date === "string") {
        // Split the date string into day, month, year
        const [day, month, year] = date.split("/");
        // Create date using year-month-day format (which dayjs handles correctly)
        const converted = dayjs(`${year}-${month}-${day}`).startOf("day");
        return converted;
      }
      return dayjs(date);
    }

    function convertToDateStr(date) {
      return date.format("DD/MM/YYYY");
    }

    function normalizePostcode(postcode) {
      if (!postcode) return "";
      const cleanPostcode = postcode.toString().trim();
      return cleanPostcode.length === 3 ? `0${cleanPostcode}` : cleanPostcode;
    }

    function validateRules(date, postcode, rules, invalidatedRules, overrides) {
      const normalizedPostcode = normalizePostcode(postcode);
      console.log("Validating attribute rules for:", {
        date: date.format("DD/MM/YYYY"),
        rules,
        invalidatedRules,
        overrides,
      });

      // Filter out overridden rules
      const nonOverriddenRules = rules.filter(
        (rule) => !overrides.includes(rule.title)
      );

      // Only check attribute rules (rules with field property)
      const matchingRules = nonOverriddenRules.filter((rule) => {
        // Skip if rule doesn't have required fields
        if (!rule.field || !rule.operator || !rule.values) {
          return false;
        }

        let fieldMatch = false;
        switch (rule.field) {
          case "Delivery Date":
            if (
              rule.operator === "Equals" &&
              rule.values?.includes(convertToDateStr(date))
            ) {
              fieldMatch = true;
            } else if (
              rule.operator === "Not Equals" &&
              !rule.values?.includes(convertToDateStr(date))
            ) {
              fieldMatch = true;
            }
            break;
          case "Delivery Day":
            if (
              rule.operator === "Equals" &&
              rule.values?.includes(date.format("dddd"))
            ) {
              fieldMatch = true;
            } else if (
              rule.operator === "Not Equals" &&
              !rule.values?.includes(date.format("dddd"))
            ) {
              fieldMatch = true;
            }
            break;
        }

        return fieldMatch;
      });

      const invalidatations = matchingRules.filter((rule) =>
        invalidatedRules.includes(rule.title)
      );
      if (invalidatations.length > 0) {
        return false;
      }

      const isValid = matchingRules.every((rule) => rule.is_allowed);
      console.log("Validation result:", {
        matchingRules,
        isValid,
      });

      return isValid;
    }

    function isEligbleDate(
      date,
      postcode,
      rules,
      invalidatedRules,
      overrides,
      offset,
      cutOffTime
    ) {
      let _offset = offset;
      let _date = date.clone();
      // Pass cutoff time to getToday
      const today = getToday(cutOffTime);

     // Special handling for delivery after any holiday
      const dayBefore = date.clone().subtract(1, 'day');
      const isDayAfterHoliday = rules.some(rule => 
        rule.skip_offset_check === true && 
        rule.values?.includes(convertToDateStr(dayBefore))
      );
      
      if (isDayAfterHoliday) {
        console.log(`Date ${date.format('YYYY-MM-DD')} is day after a holiday`);
        
        // Block Saturday delivery for rural postcodes (offset = 2) even in holiday case
        if (offset === 2 && date.day() === 6) {
          console.log("Rural delivery not available on Saturdays, even after holidays");
          return false;
        }
        
        // Find the last business day before the holiday
        let lastBusinessDay = dayBefore.clone().subtract(1, 'day');
        let daysChecked = 0;
        let validBusinessDays = 0;
        let requiredDays = offset; // Use the offset as the required processing days
        
        // Keep going back until we find enough valid business days
        while (daysChecked < 14) { // Limit to 14 days to prevent infinite loop
          const isBusinessDayHoliday = rules.some(rule => 
            rule.skip_offset_check === true && 
            rule.values?.includes(convertToDateStr(lastBusinessDay))
          );
          
          // Check if this is a valid business day (not a holiday, not a Sunday)
          if (!isBusinessDayHoliday && lastBusinessDay.day() !== 0) {
            validBusinessDays++;
            console.log(`Found valid business day: ${lastBusinessDay.format('YYYY-MM-DD')}, count: ${validBusinessDays}/${requiredDays}`);
            
            if (validBusinessDays >= requiredDays) {
              // We've found enough valid business days
              break;
            }
          }
          
          lastBusinessDay = lastBusinessDay.subtract(1, 'day');
          daysChecked++;
        }
        
        // If we couldn't find enough valid business days, block the delivery
        if (validBusinessDays < requiredDays) {
          console.log(`Not enough valid business days (${validBusinessDays}/${requiredDays}) - blocking delivery after holiday`);
          return false;
        }
        
        // We found enough valid business days, now check the cutoff time
        // The cutoff is on the last valid business day we found
        const cutoffDay = lastBusinessDay.clone();
        const now = dayjs();
        const businessDayCutoff = cutoffDay.hour(12).minute(0).second(0);
        
        if (now.isBefore(businessDayCutoff)) {
          console.log(`Before 12pm cutoff on ${cutoffDay.format('YYYY-MM-DD')} - allowing delivery after holiday`);
          return true;
        } else {
          console.log(`Past 12pm cutoff on ${cutoffDay.format('YYYY-MM-DD')} - blocking delivery after holiday`);
          return false;
        }
      }

      while (true) {
        if (_date.isBefore(today, "date")) {
          return false;
        }
        if (_offset < 0) {
          return false;
        }
        
        // Check if date is a shipping holiday
        const isHoliday = rules.some(rule => 
          rule.skip_offset_check === true && 
          rule.values?.includes(convertToDateStr(_date))
        );
        
        if (isHoliday) {
          console.log(`Date ${_date.format('YYYY-MM-DD')} is a shipping holiday`);
          return false;
        }
        
        const currentResult = validateRules(
          _date,
          postcode,
          rules,
          invalidatedRules,
          overrides
        );
        
        if (currentResult && _offset === 0) {
          // This means the date is valid and the offset is 0, so it is eligible
          return true;
        } else if (!currentResult && _offset > 0) {
          // This means we hit an invalid date before reaching the required offset for delivery
          return false;
        }
        _date = _date.subtract(1, "day");
        _offset--;
      }
    }

    function checkDateEligibility(_date, postcode, getNextDate = false) {
      // Early return if missing required params
      if (!_date || !postcode) {
        return [false, undefined];
      }

      // Normalize date input to dayjs object
      const date = typeof _date === "string" ? convertToDayjs(_date) : _date;

      // Get rules and weights from configs
      const { shipping_rules_data, weights } = window.DeliveryConfigs;
      const { attribute_rules, postcode_rules } = shipping_rules_data;
      const totalWeight = weights.total;

      // Find matching postcode rule that also satisfies weight limit
      const postcodeRuleIndex = postcode_rules.findIndex((rule) => {
        // First check if postcode matches (normalize both input and rule postcodes)
        const rulePostcodes = rule.postcodes
          .split(",")
          .map((p) => normalizePostcode(p.trim()));
        const normalizedInputPostcode = normalizePostcode(postcode);

        const postcodeMatches = rulePostcodes.includes(normalizedInputPostcode);

        if (!postcodeMatches) return false;

        // If it's same day delivery, check weight limit
        if (rule.days_offset === 0) {
          const maxWeight =
            shipping_rules_data.max_weights[postcode_rules.indexOf(rule)];
          if (maxWeight && totalWeight > maxWeight) {
            console.log("Postcode rule weight exceeded:", {
              rule: rule.title,
              totalWeight,
              maxWeight,
            });
            return false;
          }
        }

        return true;
      });

      const postcodeRule =
        postcodeRuleIndex !== -1 ? postcode_rules[postcodeRuleIndex] : null;
      const overrides =
        configs.shipping_rules_data.ruleOverrides.postcode[postcodeRuleIndex];
      const invalidatedRules =
        configs.shipping_rules_data.ruleNotAllowedWith.postcode[
          postcodeRuleIndex
        ];

      // Get cut-off time using same index as postcode rule
      const cutOffTime =
        shipping_rules_data.cut_off_times[postcodeRuleIndex] || "12:00";
      console.log('Rule Details:', {
                postcode,
                ruleName: postcodeRule?.title,
                cutOffTime,
                isSameDay: postcodeRule?.days_offset === 0,
                currentTime: dayjs().format('HH:mm')
            });


      const requiredOffsetMappings = !postcodeRule
        ? [{ offset: 1, overrides: [], invalidatedRules: [] }]
        : postcodeRule.days_offset == 0
        ? [
            { offset: 1, overrides: [], invalidatedRules: [] },
            { offset: 0, overrides, invalidatedRules },
          ]
        : [
            {
              offset: postcodeRule.days_offset,
              overrides: overrides,
              invalidatedRules: invalidatedRules,
            },
          ];
      const validations = requiredOffsetMappings.map((offsetMapping) => {
        return isEligbleDate(
          date,
          postcode,
          attribute_rules,
          offsetMapping.invalidatedRules,
          offsetMapping.overrides,
          offsetMapping.offset,
          cutOffTime
        );
      });

      const isEligible = validations.some((validation) => validation);

      let nextDate = undefined;
      if (getNextDate) {
        let _newDate = date.add(1, "day");
        while (true) {
          const eligibilities = requiredOffsetMappings.map((offsetMapping) =>
            isEligbleDate(
              _newDate,
              postcode,
              attribute_rules,
              offsetMapping.invalidatedRules,
              offsetMapping.overrides,
              offsetMapping.offset,
              cutOffTime
            )
          );
          if (eligibilities.some((eligibility) => eligibility)) {
            nextDate = _newDate;
            break;
          }
          _newDate = _newDate.add(1, "day");
        }
      }

      return [isEligible, nextDate];
    }

    // TODO
    const setDefaultDateOnRefresh = function () {
      let todayDate = dayjs();
      const [isEligible, minNextPossibleDate] = checkDateEligibility(
        todayDate,
        configs.cart_delivery_details?.postcode,
        true
      );
      if (!minNextPossibleDate && !isEligible) {
        return;
      }
      let minPossibleDate = isEligible ? todayDate : minNextPossibleDate;
      const currentDate = $(target).datepicker("getDate")
        ? convertToDayjs($(target).datepicker("getDate"))
        : null;

      if (!currentDate || currentDate.isBefore(minPossibleDate)) {
        $(target).datepicker("setDate", minPossibleDate.format("DD/MM/YYYY"));
      } else {
        $(target).datepicker("setDate", currentDate.format("DD/MM/YYYY"));
      }
    };

    function addPostcodeChecker(caller = "init") {
      console.log("addPostcodeChecker called by", caller);
      // Remove existing checker to prevent duplicates
      // $("#ui-datepicker-div .postcode-checker").remove();

      const postcodeHtml = `
        <div id="postcode-check" class="postcode-checker">
          <label>Enter post code to check delivery availability</label>
          <div class="postcode-checker__wrapper">
            <input 
              type="text" 
              id="delivery-postcode" 
              placeholder="Postcode" 
              value="${
                window.DeliveryConfigs.cart_delivery_details?.postcode || ""
              }"
            >
            <button 
              id="check-postcode" 
              class="btn btn--secondary"
            >Check</button>
          </div>
          <label style="display:none" id="postcode-error-msg"></label>
        </div>
      `;

      $("#ui-datepicker-div").prepend(postcodeHtml);

      // Reattach click handler
      $("#check-postcode").on("click", function () {
        const postcode = $("#delivery-postcode").val();
        if (postcode) {
          configs.cart_delivery_details.postcode = postcode;
          window.DeliveryConfigs.cart_delivery_details = {
            postcode: postcode,
            date: null,
            day: null,
          };
          $("#day_delivery").datepicker("hide");
          $("#day_delivery").datepicker("show");
          // setTimeout(function() {
          //   addPostcodeChecker('checkPostcode');
          //   setDefaultDateOnRefresh();
          // }, 1000);
        }
      });
    }

    // TODO
    if (
      configs.cart_delivery_details.date &&
      configs.cart_delivery_details.day &&
      configs.cart_delivery_details.postcode
    ) {
        const reformattedCartDate = configs.cart_delivery_details.date.split('/').reverse().join('-');      
        if(configs.product_date_rule && configs.product_date_rule.start_date <= reformattedCartDate && configs.product_date_rule.end_date >= reformattedCartDate) {
            $(target).val(configs.cart_delivery_details.date);
            $(weekday).val(configs.cart_delivery_details.day);
            const eligible = checkDateEligibility(configs.cart_delivery_details.date, configs.cart_delivery_details.postcode);
            if (eligible[0]) {
                $(target).datepicker('setDate', configs.cart_delivery_details.date);
            }
        }
    }

    $(target).datepicker({
      ...(configs.product_date_rule ? {
                minDate: new Date(configs.product_date_rule.start_date),
                maxDate: new Date(configs.product_date_rule.end_date)
          } : {}),
      beforeShowDay: function beforeShowDay(date) {
        // return [true, ''];

        if (!configs.cart_delivery_details?.postcode) {
          return [true, ""];
        }
        const jsDate = dayjs(date);
        // TODO
        return [
          checkDateEligibility(
            jsDate,
            configs.cart_delivery_details?.postcode
          )[0],
          "",
        ];
      },
      beforeShow: function beforeShow(input, inst) {
        setTimeout(() => addPostcodeChecker("beforeShow"), 20);
        setDefaultDateOnRefresh();
      },
      onChangeMonthYear: function onChangeMonthYear(year, month, inst) {
        setTimeout(() => addPostcodeChecker("onChangeMonthYear"), 20);
      },
      dateFormat: "dd/mm/yy",
      onSelect: function onSelect() {
        var dateInstance = dayjs($(target).datepicker("getDate"));
        var selectedDate = dateInstance.format("DD/MM/YYYY");
        var selectedDay = dateInstance.format("dddd");
        var postcode = configs.cart_delivery_details.postcode;

        var scrollPos = $(window).scrollTop();

        if (!postcode) {
          $(this).val("");
          $(this).datepicker("show");

          $("#postcode-check")
            .css("position", "relative")
            .animate({ left: -10 }, 100)
            .animate({ left: 10 }, 100)
            .animate({ left: -5 }, 100)
            .animate({ left: 5 }, 100)
            .animate({ left: 0 }, 100)
            .focus();

          $("#postcode-error-msg").text(
            "Please enter postcode before selecting delivery date"
          );
          $("#postcode-error-msg").fadeIn().css({
            color: "red",
            display: "block",
          });
          setTimeout(function () {
            $(window).scrollTop(scrollPos);
          }, 0);
          throw new Error(
            "Please enter postcode before selecting delivery date"
          );
        } else {
          $("#postcode-error-msg").fadeOut();
          weekday.setAttribute("value", selectedDay);
          postcodeEL.setAttribute("value", postcode);
          $.post("/cart/update.js", {
            attributes: {
              "Delivery Postcode": postcode,
              "Delivery Date": selectedDate,
              "Delivery Day": selectedDay,
            },
          }).then(function () {
            window.DeliveryConfigs.cart_delivery_details = {
              postcode: postcode,
              date: selectedDate,
              day: selectedDay,
            };
            configs.cart_delivery_details =
              window.DeliveryConfigs.cart_delivery_details;
            $("#day_delivery").datepicker("refresh");
          });
        }
      },
    });
    $(target).on("keydown paste", function (e) {
      return e.preventDefault();
    });
    $(target).on("change", function (e) {
      var picked_date = moment(e.target.value, "DD/MM/YYYY");
      var error_msg = $("#invalid_date_message");

      if (!picked_date.isValid()) {
        error_msg.show();
        document
          .querySelector("#AddToCartForm button")
          .setAttribute("disabled", true);
        document.querySelector("#AddToCartText").innerText =
          "Check delivery date";
        return;
      }

      error_msg.hide();
      document
        .querySelector("#AddToCartForm button")
        .removeAttribute("disabled");
      document.querySelector("#AddToCartText").innerText = "Add to cart";
    }); // Add to Cart Btn

    var mealData = document.querySelector(".meals-data");

    if (mealData) {
      document
        .querySelector("#AddToCart")
        .addEventListener("click", function () {
          $(mealData).val(
            $(".product-single__variants option:selected").attr("data-meal")
          );
        });
    }
  };

  console.log(window.DeliveryConfigs);
  init_date_picker(window.DeliveryConfigs, jQuery); // Node Checkbox

  var init_note_checkbox = function init_note_checkbox() {
    var textarea = document.querySelector("#include_a_note");
    if (!textarea) return;
    textarea.setAttribute("required", true);
    var note_checkbox = document.querySelector("input#do-not-include-a-note");
    if (!note_checkbox) return;
    note_checkbox.addEventListener("click", function (e) {
      if (e.target.checked) {
        textarea.value = "";
        textarea.removeAttribute("required");
      } else {
        textarea.setAttribute("required", true);
      }
    });
  };

  function isEmptyTextarea(textarea) {
    return textarea.value.trim() === '';
  }

  document.getElementById('AddToCartForm').addEventListener('submit', function(e) {
    var textarea = document.getElementById('include_a_note');
    var checkbox = document.getElementById('do-not-include-a-note');
    
    console.log(textarea.hasAttribute('required'));
    console.log(!checkbox.checked);
    console.log(isEmptyTextarea(textarea));
    
    if (textarea.hasAttribute('required') && !checkbox.checked && isEmptyTextarea(textarea)) {
      e.preventDefault();
      e.stopPropagation();
      
      textarea.style.border = '2px solid red';
  
      setTimeout(function() {
        textarea.style.border = '';
      }, 3000);
      
      return false;
    }
  }, {capture: true});

  init_note_checkbox();
})(jQuery, dayjs);
